import { QueryClient, QueryClientProvider } from "react-query";
import { AppConfigProvider } from "./context/AppContext";
import LocaleProvider from "./context/LocaleProvider";
import { ThemeProvider } from "./context/ThemeContext";
import "./index.css";
import AppRoutes from "./routes/AppRoutes";

export default function App() {
  // React Query
  const queryClient = new QueryClient();

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AppConfigProvider>
          <LocaleProvider>
            <AppRoutes />
          </LocaleProvider>
        </AppConfigProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
